module.exports = __webpack_public_path__ + "static/img/card6-9.44a5843.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/card6-9.png
// module id = O2sX
// module chunks = 1